// extracted by mini-css-extract-plugin
export default {"wrap":"EventInstructionsField_wrap__yPRPa","item":"EventInstructionsField_item__7+1rt","status":"EventInstructionsField_status__e-zx2"};